/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Line_Too_Long_TitleInputs */



/**
* | output |
* | --- |
* | "Line Too Long" |
*
* @param {Embed_Captions_Line_Too_Long_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_line_too_long_title = /** @type {((inputs?: Embed_Captions_Line_Too_Long_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Line_Too_Long_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ligne trop longue")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeile zu lang")
	if (locale === "it") return /** @type {LocalizedString} */ ("Linea troppo lunga")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Слишком длинная строка")
	if (locale === "es") return /** @type {LocalizedString} */ ("La fila es demasiado larga")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("行过长")
	if (locale === "ja") return /** @type {LocalizedString} */ ("行が長すぎます")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लाइन बहुत लंबी है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fila muito longa")
	return /** @type {LocalizedString} */ ("Line Too Long")
});